// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: デモページ一覧
const AdminOpsDemoListApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_demo_list";

    const ExecAdminOpsDemoListApi = async () => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: {} });
    };

    return ExecAdminOpsDemoListApi;
};

export default AdminOpsDemoListApi;
